// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1KceG","header":"ReportDetails_header__2XoW7","title":"ReportDetails_title__1cJwz","left":"ReportDetails_left__3ycvF"};